import type { ReactNode } from "react";

export function EmptyState({ icon, title, body, action }: {
  icon?: ReactNode; title: ReactNode; body?: ReactNode; action?: ReactNode;
}) {
  return (
    <div className="empty">
      {icon && <div className="empty-icon">{icon}</div>}
      <h3 className="empty-title">{title}</h3>
      {body && <p className="empty-body">{body}</p>}
      {action}
    </div>
  );
}
